import * as translation from './translation.json';

export const es = {
  translation,
};
